export default "__VITE_ASSET__C1h9Sl89__"